import { createSlice } from "@reduxjs/toolkit";
import {
  fetchVaccinations,
  addVaccination,
  updateVaccination,
  removeVaccination,
} from "../../../Profile/redux/thunks/vaccinationThunks";

const initialState = { data: [], loading: false, error: null, hasFetched: false };

const vaccinationSlice = createSlice({
  name: "vaccinations",
  initialState,
  reducers: {
    resetVaccinations: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchVaccinations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVaccinations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];
        state.hasFetched = true;
      })
      .addCase(fetchVaccinations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.hasFetched = true;
      })
      // ADD
      .addCase(addVaccination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addVaccination.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) state.data.unshift(action.payload);
      })
      .addCase(addVaccination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // UPDATE
      .addCase(updateVaccination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVaccination.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.data.findIndex((x) => x.id === action.payload?.id);
        if (idx !== -1) state.data[idx] = action.payload;
      })
      .addCase(updateVaccination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // DELETE
      .addCase(removeVaccination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeVaccination.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((x) => x.id !== action.payload);
      })
      .addCase(removeVaccination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetVaccinations } = vaccinationSlice.actions;
export default vaccinationSlice.reducer;


